import React from 'react';
import { ConnectedServiceSelection } from '../ServiceSelection';
import { ConnectedProjectSelection } from '../ProjectSelection';
import { ConnectedConnectionSelection } from '../ConnectionSelection';
import { ConnectedEnterTabName } from '../TabNameInput';
import { ConnectedDefaultRouteSelection } from '../DefaultRouteSelection';
import { Step, Wizard } from '../../Shared/Wizard';
import { ConnectedIModelSelection } from '../DesignReviewConfiguration/IModelSelection';
import { ConnectedNamedVersionSelection } from '../DesignReviewConfiguration/NamedVersionSelection';
import { ConnectedSavedViewSelection } from '../DesignReviewConfiguration/SavedViewSelection';
import { ConnectedTabSettings } from '../TabSettings/ConnectedTabSettings';
import './Config.scss';

export const Config = ({
  isPw365Project = false,
  tabConfigured = false,
  stepCallBack,
}: {
  isPw365Project?: boolean;
  tabConfigured?: boolean;
  stepCallBack: (isInSettings: boolean) => any;
}) => {
  const step = tabConfigured ? 1 : isPw365Project ? 3 : 2;

  return (
    <div id='wizard' style={{ height: '100%' }}>
      <Wizard setStepTo={step}>
        <Step id='tab-settings'>
          <ConnectedTabSettings isInSettings={stepCallBack} />
        </Step>
        <Step id='choose-project'>
          <ConnectedProjectSelection tabConfigured={tabConfigured} />
        </Step>
        {isPw365Project && (
          <Step id='choose-default-route'>
            <ConnectedDefaultRouteSelection tabConfigured={tabConfigured} />
          </Step>
        )}
        {!isPw365Project && (
          <Step id='choose-connection'>
            <ConnectedConnectionSelection tabConfigured={tabConfigured} />
          </Step>
        )}
        <Step id='enter-tab-name'>
          <ConnectedEnterTabName />
        </Step>
        <Step id='choose-imodel'>
          <ConnectedIModelSelection />
        </Step>
        <Step id='choose-named-version'>
          <ConnectedNamedVersionSelection />
        </Step>
        <Step id='choose-default-view'>
          <ConnectedSavedViewSelection tabConfigured={tabConfigured} />
        </Step>
      </Wizard>
    </div>
  );
};
